export default "__VITE_PUBLIC_ASSET__3a4b896d__"